import { render, staticRenderFns } from "./MatchSummaryCard.vue?vue&type=template&id=61d99d10&"
import script from "./MatchSummaryCard.vue?vue&type=script&lang=js&"
export * from "./MatchSummaryCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports